export const theme = {
  background: "#343434",
  primary: "#31E4A4",
  white: "#F4F4F4",
  darkGray: "#424242",
  lightGray1: "#CCCCCC",
  darkDarkGray: "#272727",
  error: "#DE3B3B"
};

export type ITheme = typeof theme;
